import React from "react"
import { Tag } from "antd"

import { getConfig } from "@components/Config"
import { useAppContext } from "@components/AppContext"

const ENVIRONMENT_LABEL = getConfig("ENVIRONMENT_LABEL")


const useOrganizationName = () => {
  const { identity } = useAppContext()
  const { organization } = identity

  const { name } = organization

  const isProductionEnvironment = ENVIRONMENT_LABEL === ""

  if (isProductionEnvironment) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center"
      }}>
        <span
          style={{
            display: "inline-block",
            maxWidth: 220,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </span>
      </div>
    )
  }

  return (
    <div style={{
      display: "flex",
      alignItems: "center"
    }}>
      <Tag
        color="purple"
        style={{ left: -2, position: "relative" }}
        bordered={false}
      >
        {ENVIRONMENT_LABEL}
      </Tag>

      <span
        style={{
          display: "inline-block",
          maxWidth: 220,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {name}
      </span>
    </div>
  )
}

export default useOrganizationName
